import { images } from "../../data/mock";
import { Button } from "../ui/button";
import { Music, ExternalLink, Headphones, Radio, Mic2 } from "lucide-react";

export const AlabanzasSection = () => {
  return (
    <section id="alabanzas" className="relative py-28 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src={images.worship}
          alt="Centro de Alabanzas"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-950/95 via-brand-950/88 to-brand-950/70" />
      </div>

      {/* Decorative */}
      <div className="absolute top-20 right-20 w-72 h-72 bg-brand-light/8 rounded-full blur-3xl animate-float" />
      <div className="absolute bottom-10 left-20 w-56 h-56 bg-brand-500/6 rounded-full blur-3xl animate-float-slow" />

      {/* Subtle dots */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: 'radial-gradient(circle, #00CCFF 1px, transparent 1px)',
        backgroundSize: '56px 56px'
      }} />

      <div className="relative z-10 max-w-7xl mx-auto px-6">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left - Content */}
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-brand-light/10 border border-brand-light/20 mb-6">
              <Music className="w-4 h-4 text-brand-light" />
              <span className="text-brand-300 text-sm font-semibold">Nuevo</span>
            </div>

            <h2 className="brand-heading text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6 leading-tight">
              Centro de
              <span className="block text-brand-light">Alabanzas</span>
            </h2>

            <p className="text-white/55 text-lg mb-8 leading-relaxed max-w-lg">
              Un espacio dedicado a la adoración y la música cristiana. 
              Accede a alabanzas, conciertos, disertaciones y contenido espiritual 
              que fortalecerá tu fe y la de tu congregación.
            </p>

            {/* Feature highlights */}
            <div className="grid grid-cols-3 gap-4 mb-10">
              <div className="p-4 rounded-2xl bg-white/[0.04] border border-brand-light/10 text-center group hover:border-brand-light/25 transition-all duration-300">
                <Headphones className="w-6 h-6 text-brand-light mx-auto mb-2 group-hover:scale-110 transition-transform duration-300" />
                <span className="text-white/50 text-xs font-medium block">Alabanzas</span>
              </div>
              <div className="p-4 rounded-2xl bg-white/[0.04] border border-brand-light/10 text-center group hover:border-brand-light/25 transition-all duration-300">
                <Radio className="w-6 h-6 text-brand-light mx-auto mb-2 group-hover:scale-110 transition-transform duration-300" />
                <span className="text-white/50 text-xs font-medium block">En Vivo</span>
              </div>
              <div className="p-4 rounded-2xl bg-white/[0.04] border border-brand-light/10 text-center group hover:border-brand-light/25 transition-all duration-300">
                <Mic2 className="w-6 h-6 text-brand-light mx-auto mb-2 group-hover:scale-110 transition-transform duration-300" />
                <span className="text-white/50 text-xs font-medium block">Conciertos</span>
              </div>
            </div>

            {/* CTA */}
            <Button
              asChild
              className="bg-brand-light hover:bg-brand-400 text-brand-950 px-8 py-6 text-lg rounded-2xl font-bold transition-all duration-300 hover:scale-105 shadow-xl shadow-brand-light/20 gap-3"
            >
              <a
                href="https://alabanzas.tuiglesia.global"
                target="_blank"
                rel="noopener noreferrer"
              >
                Visitar Centro de Alabanzas
                <ExternalLink className="w-5 h-5" />
              </a>
            </Button>

            
          </div>

          {/* Right - Visual element */}
          <div className="hidden lg:flex items-center justify-center">
            <div className="relative">
              {/* Glow behind */}
              <div className="absolute inset-0 bg-brand-light/10 rounded-full blur-3xl scale-110" />

              {/* Central visual */}
              <div className="relative w-80 h-80 rounded-full bg-white/[0.03] border border-brand-light/15 flex items-center justify-center animate-pulse-glow">
                <div className="w-60 h-60 rounded-full bg-white/[0.04] border border-brand-light/10 flex items-center justify-center">
                  <div className="w-40 h-40 rounded-full bg-brand-light/10 border border-brand-light/20 flex items-center justify-center animate-float-slow">
                    <Music className="w-16 h-16 text-brand-light/60" />
                  </div>
                </div>

                {/* Orbiting dots */}
                <div className="absolute top-4 right-12 w-3 h-3 rounded-full bg-brand-light/40 animate-float" />
                <div className="absolute bottom-8 left-8 w-2 h-2 rounded-full bg-brand-light/30 animate-float-slow" />
                <div className="absolute top-1/2 right-0 w-2.5 h-2.5 rounded-full bg-white/20 animate-float" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
